// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"houses-2"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M21 9.99951H20V21H4V9.99951H3L6 4.99951H18L21 9.99951Z"}},{"tag":"path","attrs":{"id":"fill2","fill":"props.fillColor2","d":"M10 16V21H14V16H10Z"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M10 16V21H14V16H10Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M4 9.99951V20.9999H20V9.99951M4 9.99951H20M4 9.99951H3L6 4.99951H8M20 9.99951H21L18 4.99951H8M8 4.99951V2.99951","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Houses2Icon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'houses-2',
    ref,
    icon: element,
  },
));

Houses2Icon.displayName = 'Houses2Icon';

export default Houses2Icon;
